import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 's18-ok-cancel-dialog',
  templateUrl: './ok-cancel-dialog.component.html',
  styleUrls: ['./ok-cancel-dialog.component.scss']
})
export class OkCancelDialogComponent implements OnInit {
  dialog_title: string;
  dialog_text: string;
  dialog_action_desc: string;
  dialog_hide_cancel: boolean = false;

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.dialog_title = this.data.dialog_title;
    this.dialog_text = this.data.dialog_text;
    this.dialog_action_desc = this.data.dialog_action_desc;
    this.dialog_hide_cancel = this.data.dialog_hide_cancel;
  }

  onCancel(){
    this.dialog.closeAll();
  }

  onOk(){
    this.dialog.closeAll();
  }
}
